import { ref, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import * as actionType from "../../../context/actions";

const GetPaymentData = async (state, dispatch) => {

    if (!state?.USERID) return null;

    try {
        const userRef = ref(database, `invoiceGenerator/users/${state?.USERID}/premium`);
        const snapshot = await get(userRef);
        const data = snapshot.val();

        let formattedData = [];

        if (data) {

            // ✅ Safe check for transactions
            if (data?.transactions) {
                formattedData = Object.entries(data.transactions)
                    .map(([id, info]) => ({
                        id,
                        ...info,
                        createdAt: info?.createdAt
                            ? parseInt(info.createdAt)
                            : 0
                    }))
                    // ✅ Sort latest first (stable order after refresh)
                    .sort((a, b) => b.createdAt - a.createdAt)
                    // ✅ Add serial number after sorting
                    .map((item, index) => ({
                        ...item,
                        srNo: index + 1
                    }));
            }

            // ✅ Premium date parsing (safe)
            let premiumDate = null;

            if (data?.premiumLastDate) {
                const timestamp =
                    data.premiumLastDate.toString().length > 10
                        ? parseInt(data.premiumLastDate)
                        : parseInt(data.premiumLastDate) * 1000;

                premiumDate = new Date(timestamp);
            }

            if (premiumDate) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const isValidDate = premiumDate.getTime() >= today.getTime();

                if (isValidDate) {
                    dispatch({ type: actionType.PREMIUM, payload: true });
                    dispatch({
                        type: actionType.PREMIUMLASTDATE,
                        payload: premiumDate.toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric"
                        })
                    });
                } else {
                    dispatch({ type: actionType.PREMIUM, payload: false });
                }
            } else {
                dispatch({ type: actionType.PREMIUM, payload: false });
            }

            dispatch({ type: actionType.PAYMENT, payload: formattedData });

        } else {
            dispatch({ type: actionType.PREMIUM, payload: false });
        }

        return formattedData;

    } catch (error) {
        console.error("Error fetching payment data:", error);
        return null;
    }
};

export default GetPaymentData;
